exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".testsmartcontracts-collapse {\n  max-height: 80vh;\n  overflow-y: auto;\n}\n.testsmartcontracts-panel .ant-collapse-content > .ant-collapse-content-box {\n  overflow-y: auto;\n  max-height: 60vh;\n}\n.testsmartcontracts-panel-external-repeatExecution {\n  width: 5em;\n  height: 2em;\n}\n.testsmartcontracts-output {\n  margin-top: 3.1em !important;\n  overflow: auto;\n  max-height: 80vh;\n}\n", ""]);

// exports
